export const GET_DOCUMENT_CATEGORIES_REQUEST="GET_DOCUMENT_CATEGORIES_REQUEST";
export const GET_DOCUMENT_CATEGORIES_SUCCESS="GET_DOCUMENT_CATEGORIES_SUCCESS";
export const GET_DOCUMENT_CATEGORIES_FAILURE="GET_DOCUMENT_CATEGORIES_FAILURE";

export const GET_DOCUMENT_SUB_CATEGORIES_REQUEST="GET_DOCUMENT_SUB_CATEGORIES_REQUEST";
export const GET_DOCUMENT_SUB_CATEGORIES_SUCCESS="GET_DOCUMENT_SUB_CATEGORIES_SUCCESS";
export const GET_DOCUMENT_SUB_CATEGORIES_FAILURE="GET_DOCUMENT_SUB_CATEGORIES_FAILURE";
